import { CampaignChannel } from "./types";

interface CampaignDetailsCardProps {
  campaignName: string;
  campaignNotes: string;
  channel: CampaignChannel;
  onChannelChange: (value: CampaignChannel) => void;
  onCampaignNameChange: (value: string) => void;
  onCampaignNotesChange: (value: string) => void;
}

export default function CampaignDetailsCard({
  campaignName,
  campaignNotes,
  channel,
  onChannelChange,
  onCampaignNameChange,
  onCampaignNotesChange,
}: CampaignDetailsCardProps) {
  return (
    <div className="card">
      <div className="card-title">Campaign Details</div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label">Name</label>
          <input
            className="form-input"
            value={campaignName}
            onChange={(event) => onCampaignNameChange(event.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Channel</label>
          <select
            className="form-input"
            value={channel}
            onChange={(event) =>
              onChannelChange(event.target.value as CampaignChannel)
            }
          >
            <option value="SMS">SMS</option>
            <option value="WHATSAPP">WhatsApp</option>
          </select>
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Campaign Notes</label>
        <textarea
          className="form-input"
          rows={3}
          value={campaignNotes}
          onChange={(event) => onCampaignNotesChange(event.target.value)}
        />
      </div>
    </div>
  );
}
